import React from "react";
import HeaderComponent from "../WebSite/Header/HeaderComponent";
import FooterComponent from "../WebSite/Footer/FooterComponent";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import TitleDescription from "../TitleDescription/TitleDescription";
import { Container } from "@material-ui/core";
import CTA from "../CTA/CTA";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import CollectivesBenefits from "./CollectivesBenefits";
import CollectiveServices from "./CollectiveServices";
import CollectiveChallenges from "./CollectiveChallenges";
import CollectivesJourney from "./CollectivesJourney";
import CollectivesPartnerServices from "./CollectivesPartnerServices";
// Collective functional component
export default function Collective() {
  return (
    <>
      {/* Header component rendered */}
      <HeaderComponent />

      {/* Updates banner component rendered with a specific class and banner text */}
      <UpdatesBanner className="agriretailer-bg" bannerText="Collectives" />

      {/* Main wrapper for the content */}
      <div className="subSectionWrapper mb-0">
        <Container>
          {/* TitleDescription section explaining "Who are Collectives" */}
          <TitleDescription
            titleClass="text-start"
            classname2="text-start"
            classname="mb-0 mt-0"
            title="Who are Collectives"
            description="Collectives in the agricultural sector encompass various organized groups, including NGOs (Non-Governmental Organizations), SHGs (Self-Help Groups), FPOs (Farmer Producer Organizations), and Cooperative Societies (CS). These groups aim to enhance the economic and social well-being of their members by pooling resources, sharing knowledge, and improving access to markets and services. NGOs often provide training and advocacy, SHGs support mutual savings and credit, FPOs work to increase production and marketing efficiency, and Cooperative Societies enable collective management of agricultural activities. Through collaboration, these collectives help farmers achieve greater productivity and profitability."
          />
        </Container>
      </div>

      {/* Collective challenges section */}
      <CollectiveChallenges />

      {/* Solution Ecosystem section for Collectives with local trade and distribution */}
      <SolutionEcosystem
        title="Agribusiness Solution for Collectives"
        type="LTN"
        bodycopy="Ecosystem to do local trade & local distribution with farmer."
      />

      {/* Collective Services section */}
      <CollectiveServices />

      {/* Collectives Partner Services section */}
      <CollectivesPartnerServices />

      <div className="main-wrapper2">
        {/* Collectives Benefits section */}
        <CollectivesBenefits />
      </div>

      <div className="subSectionWrapper">
        <Container>
          {/* Collectives Journey section */}
          <CollectivesJourney />
        </Container>
      </div>

      <Container>
        <div className="subSectionWrapper">
          {/* CTA section for registration */}
          <CTA
            onClick={() => {
              // Storing userType in localStorage for "Collective"
              localStorage.setItem("userType", "Collective");
            }}
            href="/auth/3/signup"
            heading="Elevate Your Agricultural Expertise Join Us as a Collectives!"
            btnText="Register Now"
          />
        </div>
      </Container>

      {/* Footer component rendered */}
      <FooterComponent />
    </>
  );
}

